module.exports = __webpack_public_path__ + "static/img/beta_bg_12.1f249390.svg";